<template>
  <div class="section-main__warp monitor-page">
    <div class="left-content">
      <video-tree />
    </div>
    <div class="right-content">
      <video-player></video-player>
    </div>
  </div>
</template>

<script>
import videoTree from "../components/video-tree"
import VideoPlayer from "../components/video-player"
export default {
  components: {
    videoTree,
    VideoPlayer
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.monitor-page {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 12px;

  .left-content {
    width: 380px;
    height: 100%;
  }

  .right-content {
    width: calc(100% - 390px);
    height: 100%;
  }
}
</style>
